// What the Create Table wizard holds, judged on the draft it reports to the
// Data page as it goes: anything beyond a blank first step is worth a warning
// before an exit discards it (M211). A step beyond the first, a name or
// description, any column or metric, a template, or a chosen source counts.
export const isWizardDraftDirty = (draft) => {
  if (!draft) return false;
  const data = draft.tableData || {};
  return (draft.activeStep || 0) > 0
    || String(data.name || '').trim() !== ''
    || String(data.description || '').trim() !== ''
    || (data.detailColumns || []).length > 0
    || (data.attributeColumns || []).length > 0
    || (data.tableAttributeColumns || []).length > 0
    || Object.keys(data.metricColumns?.schema || {}).length > 0
    || Boolean(draft.selectedTemplateId)
    || Boolean(draft.externalSource?.connection_id);
};
